import {routeLinks} from './routeLinks'
import {Redirect, Route, Switch} from 'wouter'
import {invalidRoute} from '../Routing/invalidRoute'
import {Page} from './routeComponent'

export function Routing() {
  const routingLink = [...routeLinks()]
  return (
    <Switch>
      {routingLink.map((item) => {
        if (item.subLinks) {
          const parentRoute = (
            <Page key={item.linkRoute} path={item.linkRoute} content={item.content} title={item.label} />
          )
          const childRoutes = item.subLinks.map((subLink) => (
            <Page key={subLink.linkRoute} path={subLink.linkRoute} content={subLink.content} title={subLink.label} />
          ))
          return [parentRoute, childRoutes]
        } else {
          return <Page key={item.linkRoute} path={item.linkRoute} content={item.content} title={item.label} />
        }
      })}
      <Route path={invalidRoute('/:rest*')}>
        <Redirect to={'/'} />
      </Route>
    </Switch>
  )
}
